export const DELIVERY = "DELIVERY";
export const PICKUP = "PICKUP";
